var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.502348"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.168945 16C0.168945 7.16339 7.4333 0 16.3943 0C25.3553 0 32.6196 7.16346 32.6196 16C32.6196 24.8365 25.3553 32 16.3943 32C7.4333 32 0.168945 24.8366 0.168945 16ZM17.8487 16H21.0862L21.4842 11.6979H18.0171V9.97738C18.0171 9.13927 18.5834 8.94385 18.9812 8.94385H21.4289V5.25797L18.059 5.24458C14.3181 5.24458 13.4681 7.99367 13.4681 9.7533V11.6979H11.3048V16H13.4858V26.7554H17.8487V16Z","fill":"white"})));
}

FacebookInline.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
